import { render } from "./MainView.vue?vue&type=template&id=32a5dd6f&scoped=true"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=32a5dd6f&lang=css"
import "./MainView.vue?vue&type=style&index=1&id=32a5dd6f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a5dd6f"]])

export default __exports__